export default __webpack_public_path__ + "static/media/adicionar.36350eeb.svg";